export default "__VITE_ASSET__BZEGsZeM__"